import { useCallback, useState, useEffect } from 'react';
import { MapContainer } from 'react-leaflet';

import Navbar from '../Navbar/Navbar';
import UpdatesPopUp from '../UpdatesPopUp/UpdatesPopUp';
import CustomPanel from './components/CustomPanel';
import MinimizeButton from './components/MinimizeButton';
import Footer from '../Footer/Footer';
import BottomDrawer from '../BottomDrawer/BottomDrawer';
import ZoomSliderControl from './components/ZoomSliderControl';
import ProgressDashboardService from '../ProgressDashboardService/ProgressDashboardService';
import PendingReviewForm from './components/PendingReviewForm';
import './MapView.css';
import 'leaflet/dist/leaflet.css';

const MapView = () => {
	const [drawerOpen, setDrawerOpen] = useState(false);
	const [navbarDrawerOpen, setNavbarDrawerOpen] = useState(false);
	const [bottomDrawerOpen, setBottomDrawerOpen] = useState(false);
	const [drawerToggleDisabled, setDrawerToggleDisabled] = useState(true);
	const [pendingReview, setPendingReview] = useState(null);
	const isMobile = useIsMobile(768);

	const handleNavbarDrawerToggle = isOpen => {
		setNavbarDrawerOpen(isOpen);
	};

	const handleBottomDrawerToggle = () => {
		setBottomDrawerOpen(!bottomDrawerOpen);
	};

	const enableDrawerToggle = () => {
		setDrawerToggleDisabled(false);
	};

	const openBottomDrawer = () => {
		setDrawerToggleDisabled(false);
		setBottomDrawerOpen(true);
	};

	const openPendingReview = useCallback(reviewData => {
		setPendingReview(reviewData);
	}, []);

	const closePendingReview = useCallback(() => {
		setPendingReview(null);
	}, []);

	function useIsMobile(maxWidth = 768) {
		const [isMobile, setIsMobile] = useState(window.innerWidth <= maxWidth);

		useEffect(() => {
			const handleResize = () =>
				setIsMobile(window.innerWidth <= maxWidth);
			window.addEventListener('resize', handleResize);
			return () => window.removeEventListener('resize', handleResize);
		}, [maxWidth]);

		return isMobile;
	}

	return (
		<div className="page-container">
			<Navbar onDrawerToggle={handleNavbarDrawerToggle} />
			<UpdatesPopUp drawerOpen={drawerOpen} />
			<div className="map-wrapper" style={{ position: 'relative' }}>
				{!isMobile && <MinimizeButton />}
				<MapContainer
					attributionControl={false}
					center={[-24.8844, -52.4622]}
					zoom={7}
					minZoom={4}
					maxZoom={18}
					zoomControl={false}
					zoomSnap={0.6}
					zoomDelta={0.6}
					className="main-map-container"
				>
					{!isMobile && <ZoomSliderControl />}
					<CustomPanel
						enableDrawerToggle={enableDrawerToggle}
						openBottomDrawer={openBottomDrawer}
						onPendingReviewOpen={openPendingReview}
					/>
					<BottomDrawer
						disableToggle={drawerToggleDisabled}
						isOpen={bottomDrawerOpen}
						onToggle={handleBottomDrawerToggle}
					/>
				</MapContainer>
				<ProgressDashboardService />
				<PendingReviewForm
					open={Boolean(pendingReview)}
					review={pendingReview}
					onClose={closePendingReview}
				/>
			</div>
			<Footer />
		</div>
	);
};

export default MapView;
